import React from 'react';
import * as ds from './dataService';
import { FormBaseLayout } from 'modules/components/layer10';
import { StyledTextField } from 'modules/components/layer01';
import { Stack } from '@mui/material';
import { authUtil } from 'modules/common';
import * as types from './types';


export type LoginFormProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: LoginFormProps) => {
  const form = ds.useFormState();

  const handleLogin = async (data: ds.IFormState) => {
    form.dispatch({
      type: 'UPDATE',
      payload: {
        property: 'loading',
        value: true
      }
    });
    if (data.authState === 'NOT_STARTED') {
      try {
        const authStatus = await authUtil.signIn(form.formState.email, form.formState.password);

        // if (authStatus.nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
        //   form.dispatch({
        //     type: 'UPDATE',
        //     payload: {
        //       property: 'authState',
        //       value: authStatus.nextStep.signInStep
        //     }
        //   });
        // }
        if (authStatus.nextStep.signInStep !== 'DONE') {
          form.dispatch({
            type: 'UPDATE',
            payload: {
              property: 'authState',
              value: authStatus.nextStep.signInStep
            }
          });
        }

        // console.log(authStatus.nextStep);
      } catch (err) {
        window.alert(err);
        console.error(err);
      }
    } else if (data.authState === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
      try {
        authUtil.holdEvents();
        // confirm signin
        await authUtil.confirmSignIn(form.formState.newPassword);

        authUtil.releaseEvents();
        await authUtil.signIn(data.email, data.newPassword);
      } catch (error) {
        window.alert(error);
      }
    } else if (data.authState === 'RESET_PASSWORD') {
      try {
        authUtil.holdEvents();

        await authUtil.confirmResetPassword({
          email: form.formState.email, password: form.formState.newPassword, confirmationCode: form.formState.confirmationCode
        });

        await authUtil.signIn(data.email, data.newPassword);

      } catch (error) {
        window.alert(error);
      }
    }
    authUtil.releaseEvents();
    form.dispatch({
      type: 'UPDATE',
      payload: {
        property: 'loading',
        value: false
      }
    });
  };
  return (

    <FormBaseLayout.FC
      handleCancel={() => { }}
      handleSubmit={async () => await handleLogin(form.formState)}
      ignoreCancel={true}
      isLoading={form.formState.loading}
      successButtonText={__authStep2Title[form.formState.authState]}
    >
      <Stack
        rowGap='2rem'
        paddingBottom='2rem'
      >
        {__authStep2Fields[form.formState.authState].map((node, i) => (
          <StyledTextField.FC

            {...form.genFieldProps(node)}
            key={`login-${i}`}
          />

        ))}
      </Stack>


    </FormBaseLayout.FC>

  );
};

const __authStep2Fields: Record<types.IAuthState, (keyof ds.IFormState)[]> = {
  NOT_STARTED: [
    'email',
    'password'
  ],
  CREATE_PASSWORD: [],
  SELECT_MFA_METHOD: [],
  CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE: [],
  CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED: [
    'newPassword',
    'confirmPassword'
  ],
  CONFIRM_SIGN_IN_WITH_SMS_CODE: [],
  CONFIRM_SIGN_IN_WITH_EMAIL_CODE: ['confirmationCode'],
  CONFIRM_SIGN_IN_WITH_TOTP_CODE: [],
  CONFIRM_SIGN_UP: [],
  CONTINUE_SIGN_IN_WITH_MFA_SELECTION: [],
  CONTINUE_SIGN_IN_WITH_TOTP_SETUP: [],
  CONFIRM_SIGN_IN_WITH_PASSWORD: [],
  CONTINUE_SIGN_IN_WITH_EMAIL_SETUP: [],
  CONTINUE_SIGN_IN_WITH_FIRST_FACTOR_SELECTION: [],
  CONTINUE_SIGN_IN_WITH_MFA_SETUP_SELECTION: [],
  RESET_PASSWORD: [
    'confirmationCode',
    'newPassword',
    'confirmPassword'
  ],
  COMPLETE_AUTO_SIGN_IN: [],
  DONE: []
};

const __authStep2Title: Record<types.IAuthState, string> = {
  NOT_STARTED: 'Login',
  CREATE_PASSWORD: '',
  SELECT_MFA_METHOD: '',
  CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE: '',
  CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED: 'Enter New Password',
  CONFIRM_SIGN_IN_WITH_SMS_CODE: '',
  CONFIRM_SIGN_IN_WITH_EMAIL_CODE: 'Enter Code sent to your email',
  CONFIRM_SIGN_IN_WITH_TOTP_CODE: '',
  CONFIRM_SIGN_UP: '',
  CONTINUE_SIGN_IN_WITH_MFA_SELECTION: '',
  CONTINUE_SIGN_IN_WITH_TOTP_SETUP: '',
  CONFIRM_SIGN_IN_WITH_PASSWORD: '',
  CONTINUE_SIGN_IN_WITH_EMAIL_SETUP: '',
  CONTINUE_SIGN_IN_WITH_FIRST_FACTOR_SELECTION: '',
  CONTINUE_SIGN_IN_WITH_MFA_SETUP_SELECTION: '',
  DONE: '',
  RESET_PASSWORD: 'Confirm New Password',
  COMPLETE_AUTO_SIGN_IN: ''
};
